const BaseComponent = require('common/home-block/extend');
class sasacInformation extends BaseComponent {
  init () {
    super.init();
  }
}
module.exports = sasacInformation;
